<app-header [lockIcon]="currentLockIcon"></app-header>
<main class="timeapp saved-worktimes" style="display: flex; flex-direction: column;">
	<div style="width: 100%; justify-content: center; align-items: center; padding: 0.5em 0;  display: flex;">
		<mat-icon (click)="previous()" class="arrow-icon">chevron_left</mat-icon>
		<mat-form-field appearance="outline" style="width: auto;">
			<mat-label>{{ "TIMEENTRY.Datum" | translate }}</mat-label>
			<div class="time-container">
				<div style="display: flex; column-gap: 0.2em">
					<div style="height: 0;">{{ day }}</div>
					<div>-</div>
					<input [formControl]="formValue" [matDatepicker]="picker" matInput/>
				</div>
			</div>
			<mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
			<mat-datepicker #picker [dateClass]="dateClass()"></mat-datepicker>
		</mat-form-field>
		<mat-icon (click)="next()" class="arrow-icon">chevron_right</mat-icon>
	</div>

	@let result = savedEntries | async;
	@if (result) {
		<div *ngIf="result.length > 0" style="text-align: center; margin-bottom: 1rem">
			<h3 *ngIf="!totalTimeDifferencesExists">{{ "TIMEENTRY.Gesamtzeit" | translate }} {{ totalTime }}h</h3>
			<h3 *ngIf="totalTimeDifferencesExists">{{ "TIMEENTRY.Gesamtzeit" | translate }}
				<span class="time_difference">{{ totalTime }}h </span>
				<span style="color: red">{{ totalTimeAfterControl }}h</span>
			</h3>
		</div>

		<div style="overflow-y: scroll;">
			<div>
				<mat-divider></mat-divider>
				<mat-list *ngFor="let item of result; let last = last; let index = index">
					<ng-container *ngIf="(index - 1) >= 0 && checkDifference(result[index-1], result[index])">
						<mat-list-item>
							<div class="gapContainer">
								<div>PAUSE</div>
								<ng-container *ngIf="!result[index-1].end">
									<div>{{ result[index - 1].originalEnd }} - {{ result[index].originalStart }}</div>
								</ng-container>
								<ng-container *ngIf="result[index-1].end">
									<div>{{ result[index - 1].end }} - {{ result[index].start }}</div>
								</ng-container>
							</div>
						</mat-list-item>
						<mat-divider></mat-divider>
					</ng-container>

					<mat-list-item [ngClass]="{'timeConflict': hasTimeConflictBetweenEntries(result[index-1], item)}" style="display: flex; width: 100%;">
						<fa-icon *ngIf="item?.iconAction" [icon]="item?.iconAction" [ngStyle]="{color: (item.deleted) ? 'red' : 'lightgray'}"></fa-icon>
						<div style="overflow: auto; width: 100%;">
							<div [innerHTML]="getItemDescription(item)" [ngClass]="getDescStyle(item)"></div>
							<div *ngIf="item.deleted === false">
								<span [style]="getTimeStyle(item)">{{ getDisplayDifferences(item) }}</span><span>{{ getSpace(item) }}</span>
								<span [style]="getTimeRedStyle(item)">{{ getDisplayStart(item) + getDisplayEnd(item) }} </span>
							</div>
							<div *ngIf="item.deleted" ngClass="is_deleted">
							{{ item?.originalStart }}
							<ng-container *ngIf="item?.originalStart">
								<span>-</span>
							</ng-container>
							{{ item?.originalEnd }}
							{{ item?.originalTimeAmount + "h" }}
							</div>
							<div *ngIf="item.costCenterID" [ngClass]="item.deleted ? 'is_deleted' : ''">
								{{ item?.costCenterID }}
								{{ item?.description }}
							</div>
							<div *ngIf="item.expenseDescription" [ngClass]="item.deleted ? 'is_deleted' : ''">
								{{ item.expenseDescription }} {{ item.expenseAmount }} x
								{{ item.expenseRate }} CHF
							</div>
							<div *ngIf="item.note" [ngClass]="item.deleted ? 'is_deleted' : ''">
								{{ item.note }}
							</div>
						</div>
						<div style="display: flex; align-items: center; flex-direction: column; justify-content: center;">
							<mat-icon *ngIf="userPermissions?.noDataEditOnHandy === 0" [matMenuTriggerFor]="menu" class="info-icon" style="background: transparent; border: none; padding: 0">info
							</mat-icon>
							<mat-menu #menu="matMenu">
								<button (click)="timeStart(item)" *ngIf="!item.deleted" mat-menu-item>
									{{ "TIMEENTRY.Zeit starten" | translate }}
								</button>
								<button (click)="editOrder(item)" *ngIf="!item.deleted" mat-menu-item>
									{{ "TIMEENTRY.Auftrag bearbeiten" | translate }}
								</button>
								<button (click)="copyOrder(item)" mat-menu-item>
									{{ "TIMEENTRY.Auftrag kopieren" | translate }}
								</button>
								<button (click)="deleteOrder(item)" mat-menu-item>
									{{ "TIMEENTRY.Eintrag loeschen" | translate }}
								</button>
							</mat-menu>
							<mat-icon (click)="editOrder(item)" class="red-arrow">arrow_forward</mat-icon>
						</div>
					</mat-list-item>

					<mat-divider *ngIf="!last"></mat-divider>
				</mat-list>
				<div *ngIf="result?.length === 0" style="text-align: center">
					{{ "TIMEENTRY.keine Daten gefunden" | translate }}
				</div>
			</div>
		</div>

		<div *ngIf="result.length > 5" style="text-align: center">
			<br/>
			<mat-icon class="info-icon">arrow_downward</mat-icon>
		</div>
	}
</main>

<footer class="timeapp">
	<mat-icon (click)="goBack()" class="icon-size"> arrow_back</mat-icon>
	<mat-icon (click)="closeDay()" class="icon-size"> done</mat-icon>
	<mat-icon (click)="dataSync()" [ngStyle]="{'color': !helperService.isWebServiceAvailable()? 'lightgrey' : 'white' }" class="icon-size">
		sync
	</mat-icon>
	<mat-icon (click)="startEmptyOrderWithPickedDate()" *ngIf="userPermissions?.noDataEditOnHandy === 0" class="icon-size"> add</mat-icon>
	<mat-icon (click)="openDay()" class="icon-size"> free_cancellation</mat-icon>
</footer>
